import React, { useContext, useEffect, useState } from "react";
import {
  Check,
  Eye,
  X,
  Users,
  CreditCard,
  AlertTriangle,
  Package,
  UserMinus,
  Bell,
  ShieldAlert,
  Store,
  Bell as BellIcon,
} from "lucide-react";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout ";
import "../../../assets/styles/admin/AdminNotifications.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const ICON_MAP = {
  distributor: { Icon: Store, color: "blue" },
  payment: { Icon: CreditCard, color: "green" },
  dispute: { Icon: AlertTriangle, color: "red" },
  supply: { Icon: Package, color: "teal" },
  cancel: { Icon: UserMinus, color: "orange" },
  overdue: { Icon: CreditCard, color: "red" },
  subscription: { Icon: Users, color: "purple" },
  system: { Icon: ShieldAlert, color: "gray" },
};

// const INITIAL_NOTIFS = [
//   {
//     id: 1,
//     type: "distributor",
//     title: "New Distributor Registered",
//     desc: "Zain Milk Services has registered and is pending approval",
//     time: "1 hour ago",
//     read: false,
//     detail:
//       "Zain Milk Services from DHA Lahore has submitted a distributor registration request.",
//     category: "Distributor",
//   },
//   {
//     id: 2,
//     type: "dispute",
//     title: "Escalated Dispute",
//     desc: "A dispute from Sara Khan has been escalated to admin level",
//     time: "3 hours ago",
//     read: false,
//     detail:
//       "Sara Khan's dispute regarding short delivery was unresolved by the distributor.",
//     category: "Dispute",
//   },
//   {
//     id: 3,
//     type: "payment",
//     title: "Platform Revenue Received",
//     desc: "PKR 12,500 platform fee collected from 5 distributors",
//     time: "5 hours ago",
//     read: true,
//     detail:
//       "Monthly platform fees have been auto-collected. Total: PKR 12,500.",
//     category: "Payment",
//   },
//   {
//     id: 4,
//     type: "subscription",
//     title: "Subscription Milestone",
//     desc: "Platform reached 500 active subscriptions across all distributors",
//     time: "1 day ago",
//     read: true,
//     detail:
//       "MilkyWay platform has hit 500 active milk subscriptions across all distributors.",
//     category: "Subscription",
//   },
//   {
//     id: 5,
//     type: "overdue",
//     title: "Distributor Fee Overdue",
//     desc: "Al-Noor Milk's platform fee of PKR 2,500 is 7 days overdue",
//     time: "2 days ago",
//     read: true,
//     detail: "Al-Noor Milk has not paid the monthly platform fee of PKR 2,500.",
//     category: "Payment",
//   },
//   {
//     id: 6,
//     type: "system",
//     title: "System Update Completed",
//     desc: "Platform updated to v2.4.1 — all services running normally",
//     time: "3 days ago",
//     read: true,
//     detail:
//       "MilkyWay platform was updated to version 2.4.1. All services are running normally.",
//     category: "System",
//   },
// ];

const NotifDetailModal = ({ notif, onClose }) => {
  if (!notif) return null;
  const { Icon, color } = ICON_MAP[notif.type] || {
    Icon: BellIcon,
    color: "gray",
  };
  return (
    <div className="adminNotif-overlay" onClick={onClose}>
      <div className="adminNotif-modal" onClick={(e) => e.stopPropagation()}>
        <button className="adminNotif-modal-close" onClick={onClose}>
          <X size={16} />
        </button>
        <div className="adminNotif-modal-header">
          <h4>{notif.title}</h4>
        </div>
        <div className="adminNotif-modal-meta">
          <div className={`adminNotif-modal-meta-icon ${color}`}>
            <Icon size={16} />
          </div>
          <div>
            <span className="adminNotif-modal-meta-time">
              {notif.created_at || notif.time}
            </span>
            <span className="adminNotif-modal-meta-cat">{notif.category}</span>
          </div>
        </div>
        <p className="adminNotif-modal-body">
          {notif.description || notif.detail}
        </p>
        <div className="adminNotif-modal-footer">
          <button className="adminNotif-modal-close-btn" onClick={onClose}>
            Close
          </button>
          <button className="adminNotif-modal-action-btn" onClick={onClose}>
            Go to Section
          </button>
        </div>
      </div>
    </div>
  );
};

const AdminNotificationsContent = () => {
  // const [notifs, setNotifs] = useState(INITIAL_NOTIFS);
  const [apiNotifs, setApiNotifs] = useState([]);
  const [viewNotif, setViewNotif] = useState(null);
  const [activeFilter, setActiveFilter] = useState("All");
  const [adminId, setAdminId] = useState(null);

  const [apiLoaded, setApiLoaded] = useState(false);

  const { baseUrl } = useContext(AppContext);

  const isApi = apiLoaded; //

  const filteredNotifs =
    activeFilter === "All"
      ? apiNotifs
      : apiNotifs.filter((n) => n.category === activeFilter);

  const displayNotifs = isApi ? apiNotifs : filteredNotifs;

  const getIsRead = (notif) => {
    if (isApi) return notif.status === "read";
    return notif.read === true;
  };

  const unreadCount = displayNotifs.filter((n) => !getIsRead(n)).length;
  const totalCount = displayNotifs.length;

  const markRead = (id) => {
    const adminId = localStorage.getItem("adminId");
    const formData = new FormData();
    // formData.append("mwadmin_id", adminId);
    formData.append("notification_id", id);

    if (isApi) {
      setApiNotifs((prev) =>
        prev.map((n) => (n.id === id ? { ...n, status: "read" } : n)),
      );
    } 
    // else {
    //   setNotifs((prev) =>
    //     prev.map((n) => (n.id === id ? { ...n, read: true } : n)),
    //   );
    // }

    axios
      .post(`${baseUrl}/admin/notification/markAsRead`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .catch((error) => {
        console.log("markRead error:", error);
      });
  };

  // ✅
  const markAllRead = () => {
    // console.log(localStorage.getItem("adminId"), "admin from local storage");
    console.log("Admin ID in mark all read", adminId);
    const formData = new FormData();
    formData.append("mwadmin_id", adminId.id);

    // ✅
    if (isApi) {
      setApiNotifs((prev) => prev.map((n) => ({ ...n, status: "read" })));
    }
    //  else {
    //   setNotifs((prev) => prev.map((n) => ({ ...n, read: true })));
    // }

    // ✅
    axios
      .post(`${baseUrl}/admin/notification/markAllRead`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("markAllRead response:", response.data);
        // ✅ FIX 3: Sirf tab refresh karo jab backend notifications wapis bheje
        // Pehle hamesha viewAllNotifications() call hoti thi — agar response mein
        // notifications nahi hote to empty list show hoti thi
        if (
          response.data.success === true
          // &&
          // response.data.notifications &&
          // response.data.notifications.length > 0
        ) {
          // setApiNotifs(response.data.notifications);

          viewAllNotifications(adminId.id);
          Swal.fire({
            title: "WoW!",
            icon: "success",
            confirmButtonText: "OKAY",
          });
        }
        // Agar notifications nahi bheje → local update already correct hai, kuch mat karo
      })
      .catch((error) => {
        console.log("Error marking all as read:", error);
        // Local already update hai — koi issue nahi
      });
  };

  const handleView = (notif) => {
    if (!getIsRead(notif)) {
      markRead(notif.id);
    }
    setViewNotif(notif);
  };

  const viewAllNotifications = (adminId) => {
    console.log("this is admin ID", adminId);
    const formData = new FormData();
    formData.append("mwadmin_id", adminId);

    axios
      .post(`${baseUrl}/admin/notification/viewAllNotifications`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        console.log("notifications response:", response.data);
        if (response.data.success === true) {
          setApiNotifs(response.data.notifications || []);
          setApiLoaded(true); // ✅
        }
      })
      .catch((error) => {
        console.log("API unavailable, using mock data:", error.message);
        // API fail — apiLoaded false rehga → mock data show hoga
      });
  };

  useEffect(() => {
    // const adminId = localStorage.getItem("adminId");
    setAdminId(JSON.parse(localStorage.getItem("admin")));
    const admin = JSON.parse(localStorage.getItem("admin"));

    if (!admin) return;
    viewAllNotifications(admin.id);
    // viewAllNotifications();
  }, []);

  return (
    <div className="adminNotif-page">
      <div className="adminNotif-header-row">
        <div className="adminNotif-title">
          <h2>Notifications</h2>
          <p>
            {unreadCount > 0
              ? `${unreadCount} unread notification${unreadCount > 1 ? "s" : ""}`
              : "All notifications read"}
          </p>
        </div>
        <button
          className="adminNotif-markall-btn"
          onClick={markAllRead}
          disabled={unreadCount === 0}
        >
          <Check size={14} /> Mark All as Read
        </button>
      </div>

      <div className="adminNotif-stats-row">
        <div className="adminNotif-stat-card">
          <div className="adminNotif-stat-icon blue">
            <BellIcon size={22} />
          </div>
          <div className="adminNotif-stat-info">
            <span>Total</span>
            <strong>{apiNotifs.length}</strong>
          </div>
        </div>
        <div className="adminNotif-stat-card">
          <div className="adminNotif-stat-icon orange">
            <AlertTriangle size={22} />
          </div>
          <div className="adminNotif-stat-info">
            <span>Unread</span>
            <strong>{unreadCount}</strong>
          </div>
        </div>
        <div className="adminNotif-stat-card">
          <div className="adminNotif-stat-icon green">
            <Check size={22} />
          </div>
          <div className="adminNotif-stat-info">
            <span>Read</span>
            <strong>{totalCount - unreadCount}</strong>
          </div>
        </div>
      </div>

      <div className="adminNotif-filter-row"></div>

      <div className="adminNotif-list-card">
        {/* ✅ FIX 1: Loading state bhi handle kiya */}
        {!apiLoaded && apiNotifs.length === 0 ? (
          <div className="adminNotif-empty">
            <BellIcon size={48} />
            <p>Loading...</p>
          </div>
        ) : // ) : displayNotifs.length === 0 ? (
        apiNotifs.length === 0 ? (
          <div className="adminNotif-empty">
            <BellIcon size={48} />
            <p>No notifications found</p>
          </div>
        ) : (
          // displayNotifs.map((notif) => {
          apiNotifs?.map((notif) => {
            const type = notif.type || "system";
            const title = notif.title || "Notification";
            const desc = notif.description || notif.desc || "";
            const time = notif.created_at || notif.time || "";
            // const isRead = getIsRead(notif);
            const isRead = notif.status == "read"? true : false;
            const { Icon, color } = ICON_MAP[type] || {
              Icon: BellIcon,
              color: "gray",
            };

            return (
              <div
                key={notif.id}
                className={`adminNotif-row ${!isRead ? "unread" : ""}`}
              >
                <div className={`adminNotif-icon-wrap ${color}`}>
                  <Icon size={18} />
                </div>
                <div className="adminNotif-text">
                  <span className="adminNotif-type">
                    {title}
                    <span className={`adminNotif-badge ${color}`}>
                      {notif.category || type}
                    </span>
                  </span>
                  <span className="adminNotif-desc">{desc}</span>
                  <span className="adminNotif-time">{time}</span>
                </div>
                <div className="adminNotif-actions">
                  {!isRead && <span className="adminNotif-dot" />}
                  {!isRead && (
                    <button
                      className="adminNotif-read-btn"
                      title="Mark as read"
                      onClick={() => markRead(notif.id)}
                    >
                      <Check size={16} />
                    </button>
                  )}
                  {/* <button
                    className="adminNotif-view-btn"
                    title="View details"
                    onClick={() => handleView(notif)}
                  >
                    <Eye size={16} />
                  </button> */}
                </div>
              </div>
            );
          })
        )}
      </div>

      {viewNotif && (
        <NotifDetailModal
          notif={viewNotif}
          onClose={() => setViewNotif(null)}
        />
      )}
    </div>
  );
};

const AdminNotifications = () => (
  <AdminMasterLayout>
    <AdminNotificationsContent />
  </AdminMasterLayout>
);

export default AdminNotifications;
